import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Members from "./pages/Members";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

import siteContent from "./config/siteContent";

function App() {
  return (
    <BrowserRouter>
      <NavBar brand={siteContent.brand} navItems={siteContent.nav} />
      <main>
        <Routes>
          <Route path="/" element={<Home content={siteContent.home} brand={siteContent.brand} />} />
          <Route path="/about" element={<About content={siteContent.about} />} />
          <Route path="/members" element={<Members content={siteContent.members} />} />
          <Route path="/events" element={<Events content={siteContent.events} />} />
          <Route path="/gallery" element={<Gallery content={siteContent.gallery} />} />
          <Route path="/contact" element={<Contact content={siteContent.contact} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer brand={siteContent.brand} footer={siteContent.footer} contact={siteContent.contact} />
    </BrowserRouter>
  );
}

export default App;
